import React, { useRef } from 'react';
import 'flatpickr/dist/themes/material_blue.css';
import '../style.css';
import Flatpickr from 'react-flatpickr';
import { Spanish } from 'flatpickr/dist/l10n/es';
import { Hook } from 'flatpickr/dist/types/options';

type Props = {
	label: string;
	error?: string;
	required?: boolean;
	containerStyle?: React.CSSProperties;
	showArrow?: boolean;
	isCourse?: boolean;

	dateFrom?: {
		icon?: React.ReactNode;
		placeholder?: string;
		name?: string;
		value?: Date | string;
		onClose?: Hook | undefined;
		onChange?: (date: Date[]) => void;
	};
	dateTo?: {
		placeholder?: string;
		icon?: React.ReactNode;
		name?: string;
		value?: Date | string;
		onClose?: Hook | undefined;
		onChange?: (date: Date[]) => void;
	};
} & React.InputHTMLAttributes<HTMLInputElement>;

export default function DateRangeInput({
	containerStyle,
	name,
	required,
	label,
	error,
	dateTo = {},
	dateFrom = {},
	showArrow,
	isCourse,
}: Props) {
	const fp = useRef<Flatpickr>(null);
	return (
		<div>
			<div className="mb-5 w-100" style={containerStyle}>
				{/* <div className="mb-10" style={containerStyle} onBlur={onBlur}> */}

				<label
					className={`custom-form-label ${required ? 'label-required' : ''}`}
				>
					{label}
				</label>
				<div className="d-flex">
					<div style={{ display: 'flex', width: '100%' }}>
						<div
							style={{
								position: 'relative',
								display: 'flex',
								flex: 1,
								// marginLeft: 10,
								alignItems: 'center',
								width: '100%',
							}}
						>
							{dateFrom.icon && (
								<div
									style={{ position: 'absolute', width: 26, paddingLeft: 10 }}
								>
									{dateFrom.icon}
								</div>
							)}
						</div>
						<Flatpickr
							ref={fp}
							placeholder={dateFrom.placeholder}
							options={
								isCourse
									? { enableTime: false, locale: Spanish, dateFormat: 'd F Y' }
									: {
											enableTime: true,
											locale: Spanish,
											dateFormat: 'd F Y H:i	',
									  }
							}
							name={name}
							className={`form-control form-control-solid ${
								dateFrom.icon ? 'ps-10' : ''
							} ${showArrow ? 'form-select' : ''}`}
							value={dateFrom.value}
							onChange={dateFrom.onChange}
							onClose={dateFrom.onClose}
						/>
					</div>
					<div className="d-flex w-100 ">
						<div
							style={{
								position: 'relative',
								display: 'flex',
								flex: 1,
								alignItems: 'center',
								marginLeft: 20,
								width: '100%',
							}}
						>
							{dateTo.icon && (
								<div
									style={{ position: 'absolute', width: 26, paddingLeft: 10 }}
								>
									{dateTo.icon}
								</div>
							)}
						</div>
						<Flatpickr
							placeholder={dateTo.placeholder}
							name={name}
							options={
								isCourse
									? { enableTime: false, locale: Spanish, dateFormat: 'd F Y' }
									: {
											enableTime: true,
											locale: Spanish,
											dateFormat: 'd F Y H:i	',
									  }
							}
							className={`form-control form-control-solid ${
								dateTo.icon ? 'ps-10' : ''
							} ${showArrow ? 'form-select' : ''}`}
							onChange={dateTo.onChange}
							onClose={dateTo.onClose}
							value={dateTo.value}
						/>
					</div>
				</div>
			</div>
			<div className="mb-10 mt-0">
				{error && <span className="error-message ">{error}</span>}
			</div>
		</div>
	);
}
